import type { Dict } from "./types";

export const account: Dict = {
  "account.title": {
    tr: "Hesabım",
    en: "My Account",
    de: "Mein Konto",
    fr: "Mon compte",
    ar: "حسابي",
    es: "Mi Cuenta",
  },
  "account.noSession": {
    tr: "Oturum bulunamadı",
    en: "No active session found",
    de: "Keine Sitzung gefunden",
    fr: "Session introuvable",
    ar: "لم يتم العثور على جلسة",
    es: "No se ha encontrado ninguna sesión activa",
  },
  "account.deleted": {
    tr: "Üyeliğin silindi",
    en: "Your membership has been deleted",
    de: "Deine Mitgliedschaft wurde gelöscht",
    fr: "Votre adhésion a été supprimée",
    ar: "تم حذف عضويتك",
    es: "Tu membresía ha sido eliminada",
  },
  "account.deleteAccountButton": {
    tr: "Üyeliğimi sil",
    en: "Delete my membership",
    de: "Mitgliedschaft löschen",
    fr: "Supprimer mon adhésion",
    ar: "حذف عضويتي",
    es: "Eliminar mi membresía",
  },
  "account.deleting": {
    tr: "Siliniyor...",
    en: "Deleting...",
    de: "Wird gelöscht...",
    fr: "Suppression en cours...",
    ar: "جاري الحذف...",
    es: "Eliminando...",
  },
  "account.deleteConfirmTitle": {
    tr: "Üyeliğini silmek istediğine emin misin?",
    en: "Are you sure you want to delete your membership?",
    de: "Bist du sicher, dass du deine Mitgliedschaft löschen möchtest?",
    fr: "Êtes-vous sûr de vouloir supprimer votre adhésion ?",
    ar: "هل أنت متأكد من رغبتك في حذف عضويتك؟",
    es: "¿Estás seguro de que quieres eliminar tu membresía?",
  },
  "account.giveUp": {
    tr: "Vazgeç",
    en: "Cancel",
    de: "Abbrechen",
    fr: "Annuler",
    ar: "تراجع",
    es: "Cancelar",
  },
  "account.confirmDelete": {
    tr: "Evet, sil",
    en: "Yes, delete",
    de: "Ja, löschen",
    fr: "Oui, supprimer",
    ar: "نعم، احذف",
    es: "Sí, eliminar",
  },
  "account.browseEvents": {
    tr: "Etkinliklere göz at",
    en: "Browse events",
    de: "Events entdecken",
    fr: "Parcourir les événements",
    ar: "تصفح الفعاليات",
    es: "Explorar eventos",
  },
  "account.fallbackEvent": {
    tr: "Etkinlik",
    en: "Event",
    de: "Event",
    fr: "Événement",
    ar: "فعالية",
    es: "Evento",
  },
  "account.fallbackDrink": {
    tr: "İçecek",
    en: "Drink",
    de: "Getränk",
    fr: "Boisson",
    ar: "مشروب",
    es: "Bebida",
  },
  "account.emailInvalid": {
    tr: "Geçerli bir e-posta gir",
    en: "Enter a valid email address",
    de: "Gib eine gültige E-Mail-Adresse ein",
    fr: "Veuillez saisir une adresse e-mail valide",
    ar: "أدخل بريدًا إلكترونيًا صالحًا",
    es: "Introduce una dirección de correo electrónico válida",
  },
  "account.dashboard.noEvents": {
    tr: "Şu an yayında etkinlik yok.",
    en: "No events are live right now.",
    de: "Aktuell sind keine Events online.",
    fr: "Aucun événement en direct actuellement.",
    ar: "لا توجد فعاليات حاليًا.",
    es: "No hay eventos en vivo en este momento.",
  },
  "account.dashboard.greeting": {
    tr: "Merhaba, {name} 👋",
    en: "Hey, {name} 👋",
    de: "Hey, {name} 👋",
    fr: "Bonjour, {name} 👋",
    ar: "مرحبًا، {name} 👋",
    es: "Hola, {name} 👋",
  },
  "account.dashboard.subtitle": {
    tr: "JUËN hesabınız.",
    en: "Your JUËN account.",
    de: "Dein JUËN-Konto.",
    fr: "Votre compte JUËN.",
    ar: "حسابك في JUËN.",
    es: "Tu cuenta JUËN.",
  },
  "account.dashboard.deleteTitle": {
    tr: "Üyeliğimi sil",
    en: "Delete my membership",
    de: "Mitgliedschaft löschen",
    fr: "Supprimer mon adhésion",
    ar: "حذف عضويتي",
    es: "Eliminar mi membresía",
  },
  "account.dashboard.deleteDesc": {
    tr: "Başvurundan vazgeçmek istersen üyeliğini şimdi silebilirsin. Bu işlem geri alınamaz.",
    en: "If you'd like to withdraw your application, you can delete your membership now. This can't be undone.",
    de: "Wenn du deine Bewerbung zurückziehen möchtest, kannst du deine Mitgliedschaft jetzt löschen. Das kann nicht rückgängig gemacht werden.",
    fr: "Si vous souhaitez annuler votre candidature, vous pouvez supprimer votre adhésion maintenant. Cette action est irréversible.",
    ar: "إذا كنت ترغب في التراجع عن طلبك، يمكنك حذف عضويتك الآن. لا يمكن التراجع عن هذا الإجراء.",
    es: "Si deseas retirar tu solicitud, puedes eliminar tu membresía ahora. Esto no se puede deshacer.",
  },
  "account.dashboard.deleteConfirmDesc": {
    tr: "Hesabın ve başvurun kalıcı olarak silinecek. Bu işlem geri alınamaz.",
    en: "Your account and application will be permanently deleted. This can't be undone.",
    de: "Dein Konto und deine Bewerbung werden dauerhaft gelöscht. Das kann nicht rückgängig gemacht werden.",
    fr: "Votre compte et votre candidature seront supprimés définitivement. Cette action est irréversible.",
    ar: "سيتم حذف حسابك وطلبك بشكل دائم. لا يمكن التراجع عن هذا الإجراء.",
    es: "Tu cuenta y solicitud serán eliminadas permanentemente. Esto no se puede deshacer.",
  },
  "account.dashboard.deleteFailed": {
    tr: "Üyelik silinemedi",
    en: "Membership could not be deleted",
    de: "Mitgliedschaft konnte nicht gelöscht werden",
    fr: "L'adhésion n'a pas pu être supprimée",
    ar: "تعذر حذف العضوية",
    es: "No se pudo eliminar la membresía",
  },
  "account.dashboard.balanceTitle": {
    tr: "Bakiyem",
    en: "My Balance",
    de: "Mein Guthaben",
    fr: "Mon solde",
    ar: "رصيدي",
    es: "Mi Saldo",
  },
  "account.dashboard.balanceDesc": {
    tr: "Mekanda içeceklerini J ile öde.",
    en: "Pay for your drinks at the venue with J.",
    de: "Bezahl deine Drinks im Club mit J.",
    fr: "Payez vos boissons sur place avec J.",
    ar: "ادفع ثمن مشروباتك في المكان باستخدام J.",
    es: "Paga tus bebidas en el local con J.",
  },
  "account.dashboard.topUp": {
    tr: "Bakiye Yükle",
    en: "Top Up Balance",
    de: "Guthaben aufladen",
    fr: "Charger le solde",
    ar: "شحن الرصيد",
    es: "Recargar Saldo",
  },
  "account.dashboard.menuTitle": {
    tr: "İçecek Menüsü",
    en: "Drink Menu",
    de: "Getränkekarte",
    fr: "Menu des boissons",
    ar: "قائمة المشروبات",
    es: "Carta de Bebidas",
  },
  "account.dashboard.menuDesc": {
    tr: "Mekandaki içecekler ve fiyatları.",
    en: "Drinks and prices at the venue.",
    de: "Drinks und Preise im Club.",
    fr: "Boissons et prix sur place.",
    ar: "المشروبات وأسعارها في المكان.",
    es: "Bebidas y precios en el local.",
  },
  "account.dashboard.vouchersTitle": {
    tr: "İçecek Kuponlarım",
    en: "My Drink Vouchers",
    de: "Meine Getränkegutscheine",
    fr: "Mes coupons de boisson",
    ar: "قسائم مشروباتي",
    es: "Mis Bonos de Bebida",
  },
  "account.dashboard.vouchersDesc": {
    tr: "İçecek kuponlarınızı ve QR kodlarını görüntüleyin.",
    en: "View your drink vouchers and QR codes.",
    de: "Sieh dir deine Getränkegutscheine und QR-Codes an.",
    fr: "Voir vos coupons de boisson et codes QR.",
    ar: "عرض قسائم المشروبات ورموز QR الخاصة بك.",
    es: "Ver tus bonos de bebida y códigos QR.",
  },
  "account.dashboard.ticketsTitle": {
    tr: "Biletlerim",
    en: "My Tickets",
    de: "Meine Tickets",
    fr: "Mes billets",
    ar: "تذاكري",
    es: "Mis Entradas",
  },
  "account.dashboard.ticketsDesc": {
    tr: "Aldığın biletleri ve QR kodlarını gör.",
    en: "See your tickets and QR codes.",
    de: "Sieh dir deine Tickets und QR-Codes an.",
    fr: "Voir vos billets achetés et codes QR.",
    ar: "شاهد تذاكرك ورموز QR الخاصة بها.",
    es: "Ver tus entradas y códigos QR.",
  },
  "account.dashboard.upcomingEvents": {
    tr: "Yaklaşan etkinlikler",
    en: "Upcoming events",
    de: "Kommende Events",
    fr: "Événements à venir",
    ar: "فعاليات قادمة",
    es: "Próximos eventos",
  },
  "account.dashboard.buyTicket": {
    tr: "Bilet al",
    en: "Buy ticket",
    de: "Ticket kaufen",
    fr: "Acheter un billet",
    ar: "شراء تذكرة",
    es: "Comprar entrada",
  },
  "account.dashboard.detail": {
    tr: "Detay",
    en: "Details",
    de: "Details",
    fr: "Détails",
    ar: "تفاصيل",
    es: "Detalles",
  },
  "account.dashboard.profileTitle": {
    tr: "Profilim",
    en: "My Profile",
    de: "Mein Profil",
    fr: "Mon profil",
    ar: "ملفي الشخصي",
    es: "Mi perfil",
  },
  "account.dashboard.profileDesc": {
    tr: "Bilgilerinizi görüntüleyin ve güncelleyin.",
    en: "View and update your information.",
    de: "Sieh dir deine Angaben an und aktualisiere sie.",
    fr: "Voir et mettre à jour vos informations.",
    ar: "عرض وتحديث معلوماتك.",
    es: "Visualiza y actualiza tu información.",
  },
  "account.status.pending.title": {
    tr: "Başvurunuz inceleniyor",
    en: "Your application is under review",
    de: "Deine Bewerbung wird geprüft",
    fr: "Votre demande est en cours d'examen",
    ar: "طلبك قيد المراجعة",
    es: "Tu solicitud está en revisión",
  },
  "account.status.pending.desc": {
    tr: "Ekibimiz başvurunuzu en kısa sürede değerlendirecek. Onaylandığında etkinliklere erişiminiz açılacak.",
    en: "Our team will review your application as soon as possible. Once approved, you'll get access to events.",
    de: "Unser Team prüft deine Bewerbung so schnell wie möglich. Nach der Freigabe erhältst du Zugang zu den Events.",
    fr: "Notre équipe évaluera votre demande dans les plus brefs délais. Vous aurez accès aux événements une fois approuvée.",
    ar: "سيقوم فريقنا بمراجعة طلبك في أقرب وقت ممكن. عند الموافقة، ستتمكن من الوصول إلى الفعاليات.",
    es: "Nuestro equipo revisará tu solicitud lo antes posible. Una vez aprobada, tendrás acceso a los eventos.",
  },
  "account.status.approved.title": {
    tr: "Üyeliğiniz onaylandı 🎉",
    en: "Your membership is approved 🎉",
    de: "Deine Mitgliedschaft wurde bestätigt 🎉",
    fr: "Votre adhésion est approuvée 🎉",
    ar: "تمت الموافقة على عضويتك 🎉",
    es: "¡Tu membresía ha sido aprobada 🎉",
  },
  "account.status.approved.desc": {
    tr: "JUËN'e hoş geldiniz! Artık etkinliklere bilet alabilir, içeceklerinizi önceden seçebilirsiniz.",
    en: "Welcome to JUËN! You can now buy tickets to events and pre-select your drinks.",
    de: "Willkommen bei JUËN! Du kannst jetzt Tickets für Events kaufen und deine Drinks im Voraus wählen.",
    fr: "Bienvenue chez JUËN ! Vous pouvez maintenant acheter des billets pour les événements et présélectionner vos boissons.",
    ar: "مرحباً بك في JUËN! يمكنك الآن شراء تذاكر الفعاليات واختيار مشروباتك مسبقاً.",
    es: "¡Bienvenido/a a JUËN! Ahora puedes comprar entradas para eventos y preseleccionar tus bebidas.",
  },
  "account.status.rejected.title": {
    tr: "Başvurunuz onaylanmadı",
    en: "Your application was not approved",
    de: "Deine Bewerbung wurde nicht angenommen",
    fr: "Votre demande n'a pas été approuvée",
    ar: "لم تتم الموافقة على طلبك",
    es: "Tu solicitud no fue aprobada",
  },
  "account.status.rejected.desc": {
    tr: "Maalesef üyelik başvurunuz onaylanmadı. Detay için bizimle iletişime geçebilirsiniz.",
    en: "Unfortunately, your membership application was not approved. Feel free to contact us for details.",
    de: "Leider wurde deine Mitgliedschaftsbewerbung nicht angenommen. Für Details kannst du dich gerne bei uns melden.",
    fr: "Malheureusement, votre demande d'adhésion n'a pas été approuvée. Veuillez nous contacter pour plus de détails.",
    ar: "للأسف، لم تتم الموافقة على طلب عضويتك. يمكنك التواصل معنا للحصول على التفاصيل.",
    es: "Lamentablemente, tu solicitud de membresía no fue aprobada. No dudes en contactarnos para más detalles.",
  },
  "account.profile.title": {
    tr: "Profilim",
    en: "My Profile",
    de: "Mein Profil",
    fr: "Mon profil",
    ar: "ملفي الشخصي",
    es: "Mi perfil",
  },
  "account.profile.subtitle": {
    tr: "Bilgilerinizi güncelleyin.",
    en: "Update your information.",
    de: "Aktualisiere deine Angaben.",
    fr: "Mettez à jour vos informations.",
    ar: "تحديث معلوماتك.",
    es: "Actualiza tu información.",
  },
  "account.profile.firstName": {
    tr: "Ad",
    en: "First name",
    de: "Vorname",
    fr: "Prénom",
    ar: "الاسم",
    es: "Nombre",
  },
  "account.profile.lastName": {
    tr: "Soyad",
    en: "Last name",
    de: "Nachname",
    fr: "Nom de famille",
    ar: "اسم العائلة",
    es: "Apellido",
  },
  "account.profile.email": {
    tr: "E-posta",
    en: "Email",
    de: "E-Mail",
    fr: "E-mail",
    ar: "البريد الإلكتروني",
    es: "Correo electrónico",
  },
  "account.profile.phone": {
    tr: "Telefon",
    en: "Phone",
    de: "Telefon",
    fr: "Téléphone",
    ar: "الهاتف",
    es: "Teléfono",
  },
  "account.profile.city": {
    tr: "Şehir",
    en: "City",
    de: "Stadt",
    fr: "Ville",
    ar: "المدينة",
    es: "Ciudad",
  },
  "account.profile.instagram": {
    tr: "Instagram",
    en: "Instagram",
    de: "Instagram",
    fr: "Instagram",
    ar: "Instagram",
    es: "Instagram",
  },
  "account.profile.bio": {
    tr: "Hakkımda",
    en: "About me",
    de: "Über mich",
    fr: "À propos de moi",
    ar: "عني",
    es: "Sobre mí",
  },
  "account.profile.saving": {
    tr: "Kaydediliyor...",
    en: "Saving...",
    de: "Wird gespeichert...",
    fr: "Sauvegarde en cours...",
    ar: "جاري الحفظ...",
    es: "Guardando...",
  },
  "account.profile.saveChanges": {
    tr: "Değişiklikleri kaydet",
    en: "Save changes",
    de: "Änderungen speichern",
    fr: "Enregistrer les modifications",
    ar: "حفظ التغييرات",
    es: "Guardar cambios",
  },
  "account.profile.updated": {
    tr: "Profiliniz güncellendi",
    en: "Your profile has been updated",
    de: "Dein Profil wurde aktualisiert",
    fr: "Votre profil a été mis à jour",
    ar: "تم تحديث ملفك الشخصي",
    es: "Tu perfil ha sido actualizado",
  },
  "account.profile.deleteFailed": {
    tr: "Hesap silinemedi",
    en: "Account could not be deleted",
    de: "Konto konnte nicht gelöscht werden",
    fr: "Le compte n'a pas pu être supprimé",
    ar: "تعذر حذف الحساب",
    es: "No se pudo eliminar la cuenta",
  },
  "account.profile.deleteDesc": {
    tr: "Hesabın ve tüm verilerin kalıcı olarak silinir. Bu işlem geri alınamaz.",
    en: "Your account and all your data will be permanently deleted. This can't be undone.",
    de: "Dein Konto und alle deine Daten werden dauerhaft gelöscht. Das kann nicht rückgängig gemacht werden.",
    fr: "Votre compte et toutes vos données seront définitivement supprimés. Cette action est irréversible.",
    ar: "سيتم حذف حسابك وجميع بياناتك نهائياً. لا يمكن التراجع عن هذا الإجراء.",
    es: "Tu cuenta y todos tus datos serán eliminados permanentemente. Esta acción no se puede deshacer.",
  },
  "account.profile.deleteConfirmDesc": {
    tr: "Hesabın, profilin ve tüm verilerin kalıcı olarak silinecek. Bu işlem geri alınamaz.",
    en: "Your account, profile and all your data will be permanently deleted. This can't be undone.",
    de: "Dein Konto, dein Profil und alle deine Daten werden dauerhaft gelöscht. Das kann nicht rückgängig gemacht werden.",
    fr: "Votre compte, votre profil et toutes vos données seront définitivement supprimés. Cette action est irréversible.",
    ar: "سيتم حذف حسابك وملفك الشخصي وجميع بياناتك نهائياً. لا يمكن التراجع عن هذا الإجراء.",
    es: "Tu cuenta, perfil y todos tus datos serán eliminados permanentemente. Esta acción no se puede deshacer.",
  },
  "account.tickets.title": {
    tr: "Biletlerim",
    en: "My Tickets",
    de: "Meine Tickets",
    fr: "Mes billets",
    ar: "تذاكري",
    es: "Mis entradas",
  },
  "account.tickets.subtitle": {
    tr: "Etkinliklerde QR kodunu okutarak giriş yap.",
    en: "Scan your QR code at events to get in.",
    de: "Scanne deinen QR-Code bei Events, um reinzukommen.",
    fr: "Scannez le code QR aux événements pour entrer.",
    ar: "ادخل بقراءة رمز QR في الفعاليات.",
    es: "Escanea tu código QR en los eventos para entrar.",
  },
  "account.tickets.empty": {
    tr: "Henüz bir biletin yok.",
    en: "You don't have any tickets yet.",
    de: "Du hast noch keine Tickets.",
    fr: "Vous n'avez pas encore de billet.",
    ar: "ليس لديك تذاكر بعد.",
    es: "Aún no tienes entradas.",
  },
  "account.ticketDetail.notFound": {
    tr: "Bilet bulunamadı",
    en: "Ticket not found",
    de: "Ticket nicht gefunden",
    fr: "Billet introuvable",
    ar: "لم يتم العثور على تذاكر",
    es: "Entrada no encontrada",
  },
  "account.ticketDetail.backToTickets": {
    tr: "Biletlerime dön",
    en: "Back to my tickets",
    de: "Zurück zu meinen Tickets",
    fr: "Retourner à mes billets",
    ar: "العودة إلى تذاكري",
    es: "Volver a mis entradas",
  },
  "account.ticketDetail.print": {
    tr: "Yazdır / PDF",
    en: "Print / PDF",
    de: "Drucken / PDF",
    fr: "Imprimer / PDF",
    ar: "طباعة / PDF",
    es: "Imprimir / PDF",
  },
  "account.ticketDetail.holder": {
    tr: "Bilet sahibi",
    en: "Ticket holder",
    de: "Ticketinhaber:in",
    fr: "Propriétaire du billet",
    ar: "صاحب التذكرة",
    es: "Portador de la entrada",
  },
  "account.ticketDetail.namePlaceholder": {
    tr: "Ad Soyad",
    en: "Full name",
    de: "Vor- und Nachname",
    fr: "Nom Prénom",
    ar: "الاسم واللقب",
    es: "Nombre completo",
  },
  "account.ticketDetail.nameLockedHint": {
    tr: "Bilet kullanıldıktan sonra isim değiştirilemez.",
    en: "The name can't be changed once the ticket has been used.",
    de: "Der Name kann nach der Nutzung des Tickets nicht mehr geändert werden.",
    fr: "Le nom ne peut pas être modifié après utilisation du billet.",
    ar: "لا يمكن تغيير الاسم بعد استخدام التذكرة.",
    es: "El nombre no se puede cambiar una vez que la entrada haya sido utilizada.",
  },
  "account.ticketDetail.nameHint": {
    tr: "Birden fazla bilet aldıysan her bilete farklı isim tanımlayabilirsin.",
    en: "If you bought multiple tickets, you can assign a different name to each one.",
    de: "Wenn du mehrere Tickets gekauft hast, kannst du jedem Ticket einen anderen Namen geben.",
    fr: "Si vous avez acheté plusieurs billets, vous pouvez attribuer un nom différent à chacun.",
    ar: "إذا اشتريت أكثر من تذكرة، يمكنك تخصيص اسم مختلف لكل تذكرة.",
    es: "Si compraste varias entradas, puedes asignar un nombre diferente a cada una.",
  },
  "account.ticketDetail.edit": {
    tr: "Düzenle",
    en: "Edit",
    de: "Bearbeiten",
    fr: "Modifier",
    ar: "تعديل",
    es: "Editar",
  },
  "account.ticketDetail.transferButton": {
    tr: "Bileti bir üyeye transfer et",
    en: "Transfer ticket to a member",
    de: "Ticket an ein Mitglied übertragen",
    fr: "Transférer le billet à un membre",
    ar: "تحويل التذكرة إلى عضو",
    es: "Transferir entrada a un miembro",
  },
  "account.ticketDetail.transferTitle": {
    tr: "Bileti transfer et",
    en: "Transfer ticket",
    de: "Ticket übertragen",
    fr: "Transférer le billet",
    ar: "تحويل التذكرة",
    es: "Transferir entrada",
  },
  "account.ticketDetail.transferDesc": {
    tr: "Bilet, girdiğin e-posta ile kayıtlı onaylı JUËN üyesine aktarılır. Bu işlem geri alınamaz; bilet senin hesabından kaybolur.",
    en: "The ticket will be transferred to the approved JUËN member registered with the email you enter. This can't be undone — the ticket will disappear from your account.",
    de: "Das Ticket wird an das bestätigte JUËN-Mitglied übertragen, das mit der eingegebenen E-Mail registriert ist. Das kann nicht rückgängig gemacht werden — das Ticket verschwindet aus deinem Konto.",
    fr: "Le billet sera transféré au membre vérifié de JUËN enregistré avec l'e-mail que vous avez saisi. Cette action est irréversible ; le billet disparaîtra de votre compte.",
    ar: "سيتم تحويل التذكرة إلى عضو JUËN معتمد مسجل بعنوان البريد الإلكتروني الذي أدخلته. لا يمكن التراجع عن هذا الإجراء؛ ستختفي التذكرة من حسابك.",
    es: "La entrada se transferirá al miembro de JUËN aprobado registrado con el correo electrónico que introduzcas. Esto no se puede deshacer — la entrada desaparecerá de tu cuenta.",
  },
  "account.ticketDetail.emailPlaceholder": {
    tr: "alici@ornek.com",
    en: "recipient@example.com",
    de: "empfaenger@beispiel.com",
    fr: "destinataire@exemple.com",
    ar: "receiver@example.com",
    es: "destinatario@ejemplo.com",
  },
  "account.ticketDetail.transferConfirm": {
    tr: "Transfer et",
    en: "Transfer",
    de: "Übertragen",
    fr: "Transférer",
    ar: "تحويل",
    es: "Transferir",
  },
  "account.ticketDetail.nameUpdated": {
    tr: "İsim güncellendi",
    en: "Name updated",
    de: "Name aktualisiert",
    fr: "Nom mis à jour",
    ar: "تم تحديث الاسم",
    es: "Nombre actualizado",
  },
  "account.ticketDetail.transferSuccessNamed": {
    tr: "Bilet {name} adlı üyeye transfer edildi",
    en: "Ticket transferred to {name}",
    de: "Ticket wurde an {name} übertragen",
    fr: "Billet transféré au membre nommé {name}",
    ar: "تم تحويل التذكرة إلى العضو {name}",
    es: "Entrada transferida a {name}",
  },
  "account.ticketDetail.transferSuccess": {
    tr: "Bilet transfer edildi",
    en: "Ticket transferred",
    de: "Ticket wurde übertragen",
    fr: "Billet transféré",
    ar: "تم تحويل التذكرة",
    es: "Entrada transferida",
  },
  "account.ticketDetail.info": {
    tr: "Bilet bilgisi",
    en: "Ticket info",
    de: "Ticketinfo",
    fr: "Infos billet",
    ar: "معلومات التذكرة",
    es: "Información de la entrada",
  },
  "account.ticketDetail.nameLabel": {
    tr: "Ad",
    en: "Name",
    de: "Name",
    fr: "Nom",
    ar: "الاسم",
    es: "Nombre",
  },
  "account.ticketDetail.status": {
    tr: "Durum",
    en: "Status",
    de: "Status",
    fr: "Statut",
    ar: "الحالة",
    es: "Estado",
  },
  "account.ticketDetail.checkedIn": {
    tr: "Giriş yapıldı",
    en: "Checked in",
    de: "Eingecheckt",
    fr: "Connecté",
    ar: "تم الدخول",
    es: "Registrado",
  },
  "account.ticketDetail.valid": {
    tr: "Geçerli",
    en: "Valid",
    de: "Gültig",
    fr: "Valide",
    ar: "صالح",
    es: "Válido",
  },
  "account.ticketDetail.footerLine1": {
    tr: "JUËN üyelerine özel etkinlik bileti.",
    en: "Event ticket exclusive to JUËN members.",
    de: "Event-Ticket exklusiv für JUËN-Mitglieder.",
    fr: "Billet d'événement exclusif aux membres JUËN.",
    ar: "تذكرة فعالية حصرية لأعضاء JUËN.",
    es: "Entrada de evento exclusiva para miembros de JUËN.",
  },
  "account.ticketDetail.footerLine2": {
    tr: "Girişte ve barda QR kodunuzu okutun.",
    en: "Scan your QR code at the entrance and the bar.",
    de: "Scanne deinen QR-Code am Eingang und an der Bar.",
    fr: "Scannez votre QR code à l'entrée et au bar.",
    ar: "امسح رمز QR الخاص بك عند المدخل وفي البار.",
    es: "Escanea tu código QR en la entrada y en el bar.",
  },
  "account.vouchers.subtitle": {
    tr: "Barda QR kodunu okutarak içeceğini al.",
    en: "Scan your QR code at the bar to get your drink.",
    de: "Scanne deinen QR-Code an der Bar, um deinen Drink zu bekommen.",
    fr: "Obtenez votre boisson en scannant le QR code au bar.",
    ar: "احصل على مشروبك عن طريق مسح رمز QR في البار.",
    es: "Escanea tu código QR en el bar para conseguir tu bebida.",
  },
  "account.vouchers.empty": {
    tr: "Henüz içecek kuponun yok.",
    en: "You don't have any drink vouchers yet.",
    de: "Du hast noch keine Getränkegutscheine.",
    fr: "Vous n'avez pas encore de coupon boisson.",
    ar: "ليس لديك قسيمة مشروب بعد.",
    es: "Aún no tienes ningún vale de bebida.",
  },
  "account.vouchers.available": {
    tr: "{remaining} / {total} kullanılabilir",
    en: "{remaining} / {total} available",
    de: "{remaining} / {total} verfügbar",
    fr: "{remaining} / {total} disponibles",
    ar: "{remaining} / {total} متاح",
    es: "{remaining} / {total} disponibles",
  },
  "account.vouchers.used": {
    tr: "Kullanıldı",
    en: "Used",
    de: "Eingelöst",
    fr: "Utilisé",
    ar: "مُستخدم",
    es: "Usado",
  },
  "account.vouchers.myVouchers": {
    tr: "Kuponlarım",
    en: "My Vouchers",
    de: "Meine Gutscheine",
    fr: "Mes coupons",
    ar: "قسائمي",
    es: "Mis vales",
  },
  "account.voucherDetail.sendToFriend": {
    tr: "Arkadaşına Gönder",
    en: "Send to a Friend",
    de: "An eine:n Freund:in senden",
    fr: "Envoyer à un ami",
    ar: "أرسل لصديق",
    es: "Enviar a un amigo",
  },
  "account.voucherDetail.badge": {
    tr: "İçecek Kuponu",
    en: "Drink Voucher",
    de: "Getränkegutschein",
    fr: "Coupon Boisson",
    ar: "قسيمة مشروب",
    es: "Vale de bebida",
  },
  "account.voucherDetail.notFound": {
    tr: "Kupon bulunamadı",
    en: "Voucher not found",
    de: "Gutschein nicht gefunden",
    fr: "Coupon introuvable",
    ar: "لم يتم العثور على قسيمة",
    es: "Vale no encontrado",
  },
  "account.voucherDetail.backToVouchers": {
    tr: "Kuponlarıma dön",
    en: "Back to my vouchers",
    de: "Zurück zu meinen Gutscheinen",
    fr: "Retourner à mes coupons",
    ar: "العودة إلى قسائمي",
    es: "Volver a mis vales",
  },
  "account.voucherDetail.footerLine1": {
    tr: "Bu kupon tek kullanımlıktır.",
    en: "This voucher can only be used once.",
    de: "Dieser Gutschein ist nur einmal gültig.",
    fr: "Ce coupon est à usage unique.",
    ar: "هذه القسيمة للاستخدام مرة واحدة.",
    es: "Este vale solo se puede usar una vez.",
  },
  "account.voucherDetail.footerLine2": {
    tr: "Barda QR kodunu görevliye okutun.",
    en: "Have staff scan your QR code at the bar.",
    de: "Lass den QR-Code an der Bar vom Personal scannen.",
    fr: "Faites scanner le QR code au barman.",
    ar: "امسح رمز QR للموظف في البار.",
    es: "Haz que el personal escanee tu código QR en la barra.",
  },
  "account.voucherDetail.transferTitle": {
    tr: "Kuponu Transfer Et",
    en: "Transfer Voucher",
    de: "Gutschein übertragen",
    fr: "Transférer le bon",
    ar: "تحويل القسيمة",
    es: "Transferir Vale",
  },
  "account.voucherDetail.transferDesc": {
    tr: "Kuponu göndereceğin üyenin JUËN'e kayıtlı e-postasını gir. Transfer sonrası kupon senin hesabından silinir, alıcı kullanır.",
    en: "Enter the JUËN-registered email of the member you'd like to send the voucher to. After the transfer, the voucher disappears from your account and the recipient can use it.",
    de: "Gib die bei JUËN registrierte E-Mail des Mitglieds ein, an das du den Gutschein senden möchtest. Nach der Übertragung verschwindet der Gutschein aus deinem Konto und die empfangende Person kann ihn einlösen.",
    fr: "Saisissez l'e-mail du membre enregistré chez JUËN à qui vous souhaitez envoyer le bon. Après le transfert, le bon sera supprimé de votre compte et utilisé par le destinataire.",
    ar: "أدخل البريد الإلكتروني العضو المسجل في JUËN الذي ستحول إليه القسيمة. بعد التحويل، ستُحذف القسيمة من حسابك، ويستخدمها المستلم.",
    es: "Introduce el correo electrónico registrado en JUËN del miembro al que deseas enviar el vale. Después de la transferencia, el vale desaparecerá de tu cuenta y el destinatario podrá usarlo.",
  },
  "account.voucherDetail.emailPlaceholder": {
    tr: "ornek@eposta.com",
    en: "example@email.com",
    de: "beispiel@email.com",
    fr: "exemple@email.com",
    ar: "example@email.com",
    es: "ejemplo@email.com",
  },
  "account.voucherDetail.sending": {
    tr: "Gönderiliyor...",
    en: "Sending...",
    de: "Wird gesendet...",
    fr: "Envoi en cours...",
    ar: "جارٍ الإرسال...",
    es: "Enviando...",
  },
  "account.voucherDetail.transferConfirm": {
    tr: "Transfer Et",
    en: "Transfer",
    de: "Übertragen",
    fr: "Transférer",
    ar: "تحويل",
    es: "Transferir",
  },
  "account.voucherDetail.transferSuccessNamed": {
    tr: "Kupon {name} adlı üyeye transfer edildi",
    en: "Voucher transferred to {name}",
    de: "Gutschein wurde an {name} übertragen",
    fr: "Le bon a été transféré à {name}",
    ar: "تم تحويل القسيمة للعضو {name}",
    es: "Vale transferido a {name}",
  },
  "account.voucherDetail.transferSuccess": {
    tr: "Kupon transfer edildi",
    en: "Voucher transferred",
    de: "Gutschein wurde übertragen",
    fr: "Bon transféré",
    ar: "تم تحويل القسيمة",
    es: "Vale transferido",
  },
  "account.menu.selectAtLeastOne": {
    tr: "Lütfen en az bir içecek seçin.",
    en: "Please select at least one drink.",
    de: "Bitte wähle mindestens ein Getränk aus.",
    fr: "Veuillez choisir au moins une boisson.",
    ar: "الرجاء اختيار مشروب واحد على الأقل.",
    es: "Por favor, selecciona al menos una bebida.",
  },
  "account.menu.insufficientPoints": {
    tr: "Yetersiz J. {needed} J gerekli, bakiyen {balance} J.",
    en: "Not enough J. You need {needed} J, your balance is {balance} J.",
    de: "Nicht genug J. Du brauchst {needed} J, dein Guthaben ist {balance} J.",
    fr: "J insuffisants. {needed} J nécessaires, votre solde est de {balance} J.",
    ar: "رصيد J غير كافٍ. تحتاج إلى {needed} J، رصيدك {balance} J.",
    es: "No tienes suficientes J. Necesitas {needed} J, tu saldo es {balance} J.",
  },
  "account.menu.orderFailed": {
    tr: "Sipariş oluşturulamadı",
    en: "Order could not be created",
    de: "Bestellung konnte nicht erstellt werden",
    fr: "Commande non créée",
    ar: "لم يتم إنشاء الطلب",
    es: "No se pudo crear el pedido",
  },
  "account.menu.ready": {
    tr: "İçeceklerin hazır!",
    en: "Your drinks are ready!",
    de: "Deine Drinks sind bereit!",
    fr: "Vos boissons sont prêtes !",
    ar: "مشروباتك جاهزة!",
    es: "¡Tus bebidas están listas!",
  },
  "account.menu.approvalRequiredTitle": {
    tr: "Onaylı üyelik gerekli",
    en: "Approved membership required",
    de: "Bestätigte Mitgliedschaft erforderlich",
    fr: "Adhésion confirmée requise",
    ar: "عضوية معتمدة مطلوبة",
    es: "Se requiere membresía aprobada",
  },
  "account.menu.approvalRequiredDesc": {
    tr: "İçecek menüsünü görmek için üyeliğinin onaylanması gerekir.",
    en: "Your membership needs to be approved to view the drink menu.",
    de: "Deine Mitgliedschaft muss bestätigt sein, um die Getränkekarte zu sehen.",
    fr: "Pour voir le menu des boissons, votre adhésion doit être confirmée.",
    ar: "يجب الموافقة على عضويتك لرؤية قائمة المشروبات.",
    es: "Tu membresía necesita ser aprobada para ver el menú de bebidas.",
  },
  "account.menu.subtitle": {
    tr: "İçeceklerini J ile sipariş et.",
    en: "Order your drinks with J.",
    de: "Bestell deine Drinks mit J.",
    fr: "Commandez vos boissons avec J.",
    ar: "اطلب مشروباتك باستخدام J.",
    es: "Pide tus bebidas con J.",
  },
  "account.menu.empty": {
    tr: "Henüz menüde içecek yok.",
    en: "There are no drinks on the menu yet.",
    de: "Es gibt noch keine Drinks auf der Karte.",
    fr: "Aucune boisson n'est encore au menu.",
    ar: "لا توجد مشروبات في القائمة بعد.",
    es: "Todavía no hay bebidas en el menú.",
  },
  "account.menu.alcohol": {
    tr: "%{percent} alkol",
    en: "{percent}% alcohol",
    de: "{percent}% Alkohol",
    fr: "%{percent} alcool",
    ar: "{percent}% كحول",
    es: "{percent}% de alcohol",
  },
  "account.menu.total": {
    tr: "Toplam ({count} adet)",
    en: "Total ({count} pcs)",
    de: "Gesamt ({count} Stk.)",
    fr: "Total ({count} articles)",
    ar: "الإجمالي ({count} قطعة)",
    es: "Total ({count} uds)",
  },
  "account.menu.payWithJ": {
    tr: "J ile öde",
    en: "Pay with J",
    de: "Mit J bezahlen",
    fr: "Payer avec J",
    ar: "ادفع بـ J",
    es: "Pagar con J",
  },
  "account.menu.pointsInfo": {
    tr: "{needed} J gerekli · Bakiyen: {balance} J",
    en: "{needed} J needed · Your balance: {balance} J",
    de: "{needed} J nötig · Dein Guthaben: {balance} J",
    fr: "{needed} J requis · Votre solde : {balance} J",
    ar: "مطلوب {needed} J · رصيدك: {balance} J",
    es: "{needed} J necesarios · Tu saldo: {balance} J",
  },
  "account.menu.insufficient": {
    tr: "Yetersiz",
    en: "Insufficient",
    de: "Nicht genug",
    fr: "Insuffisant",
    ar: "غير كافٍ",
    es: "Insuficiente",
  },
  "account.menu.topUpHint": {
    tr: "J yüklemek için kapıdan veya bardaki kasadan işlem yapabilirsin.",
    en: "You can top up J at the door or at the bar cashier.",
    de: "Du kannst J am Eingang oder an der Bar-Kasse aufladen.",
    fr: "Pour recharger J, vous pouvez effectuer une transaction à la porte ou à la caisse du bar.",
    ar: "لشحن J، يمكنك إجراء المعاملة من الباب أو من الكاشير في البار.",
    es: "Puedes recargar J en la entrada o en la caja de la barra.",
  },
  "account.points.noPaymentLink": {
    tr: "Bu paket için Shopier ödeme linki tanımlı değil. Yöneticiyle iletişime geçin.",
    en: "No Shopier payment link is set for this package. Please contact an admin.",
    de: "Für dieses Paket ist kein Shopier-Zahlungslink hinterlegt. Bitte wende dich an einen Admin.",
    fr: "Le lien de paiement Shopier n'est pas défini pour ce forfait. Veuillez contacter l'administrateur.",
    ar: "لا يوجد رابط دفع Shopier محدد لهذه الباقة. يرجى التواصل مع المدير.",
    es: "No se ha configurado ningún enlace de pago de Shopier para este paquete. Por favor, contacta con un administrador.",
  },
  "account.points.backToAccount": {
    tr: "Hesabıma dön",
    en: "Back to my account",
    de: "Zurück zu meinem Konto",
    fr: "Retourner à mon compte",
    ar: "العودة إلى حسابي",
    es: "Volver a mi cuenta",
  },
  "account.points.currentBalance": {
    tr: "Mevcut bakiye",
    en: "Current balance",
    de: "Aktuelles Guthaben",
    fr: "Solde actuel",
    ar: "الرصيد الحالي",
    es: "Saldo actual",
  },
  "account.points.exchangeNote": {
    tr: "1 J = 1 ₺ · Mekanda harcanır",
    en: "1 J = 1 ₺ · Spend it at the venue",
    de: "1 J = 1 ₺ · Im Club einlösbar",
    fr: "1 J = 1 ₺ · Dépensé sur place",
    ar: "1 J = 1 ₺ · تُصرف في المكان",
    es: "1 J = 1 ₺ · Gástalo en el local",
  },
  "account.points.packagesTitle": {
    tr: "J Paketleri",
    en: "J Packages",
    de: "J-Pakete",
    fr: "Forfaits J",
    ar: "باقات J",
    es: "Paquetes J",
  },
  "account.points.packagesDesc": {
    tr: "Shopier üzerinden öde, ödeme onaylanır onaylanmaz J otomatik hesabına yüklenir.",
    en: "Pay via Shopier — once your payment is confirmed, J is added to your account automatically.",
    de: "Zahle über Shopier — sobald die Zahlung bestätigt ist, wird dir J automatisch gutgeschrieben.",
    fr: "Payez via Shopier, les J seront automatiquement chargés sur votre compte dès que le paiement sera confirmé.",
    ar: "ادفع عبر Shopier، بمجرد تأكيد الدفع، سيتم إضافة J إلى حسابك تلقائيًا.",
    es: "Pagar vía Shopier — una vez confirmado tu pago, se añadirán J automáticamente a tu cuenta.",
  },
  "account.points.noPackages": {
    tr: "Şu anda satışta paket yok.",
    en: "No packages are available right now.",
    de: "Aktuell sind keine Pakete verfügbar.",
    fr: "Actuellement aucun forfait en vente.",
    ar: "لا توجد باقات للبيع حاليًا.",
    es: "No hay paquetes disponibles ahora mismo.",
  },
  "account.points.buy": {
    tr: "Satın al",
    en: "Buy",
    de: "Kaufen",
    fr: "Acheter",
    ar: "شراء",
    es: "Comprar",
  },
  "account.points.termsTitle": {
    tr: "Önemli koşullar",
    en: "Important terms",
    de: "Wichtige Bedingungen",
    fr: "Conditions importantes",
    ar: "شروط هامة",
    es: "Términos importantes",
  },
  "account.points.term1Pre": {
    tr: "J, JUËN'in kendi mal ve hizmetlerinde kullanılan",
    en: "J is a",
    de: "J ist ein",
    fr: "J est un droit d'utilisation prépayé",
    ar: "J هو حق استخدام مدفوع مسبقًا",
    es: "J es un",
  },
  "account.points.term1Strong": {
    tr: "ön ödemeli bir kullanım hakkıdır, para birimi değildir.",
    en: "prepaid usage right for JUËN's own goods and services, not a currency.",
    de: "vorausbezahltes Nutzungsrecht für JUËNs eigene Waren und Dienstleistungen, keine Währung.",
    fr: "utilisé pour les biens et services de JUËN, ce n'est pas une devise.",
    ar: "يستخدم في منتجات وخدمات JUËN الخاصة، وليس عملة نقدية.",
    es: "derecho de uso prepagado para los bienes y servicios propios de JUËN, no una moneda.",
  },
  "account.points.term2Pre": {
    tr: "Yüklenen J",
    en: "Loaded J",
    de: "Aufgeladenes J",
    fr: "Les J chargés",
    ar: "رصيد J الذي يتم تحميله",
    es: "J cargado",
  },
  "account.points.term2Strong": {
    tr: "iade edilemez",
    en: "cannot be refunded",
    de: "kann nicht erstattet werden",
    fr: "ne sont pas remboursables",
    ar: "غير قابل للاسترداد",
    es: "no puede ser reembolsado",
  },
  "account.points.term2Post": {
    tr: "ve nakde çevrilemez.",
    en: "and cannot be converted to cash.",
    de: "und kann nicht in Bargeld umgewandelt werden.",
    fr: "et ne peuvent pas être échangés contre de l'argent.",
    ar: "وغير قابل للتحويل نقدًا.",
    es: "y no se puede convertir en efectivo.",
  },
  "account.points.term3Pre": {
    tr: "J",
    en: "J",
    de: "J",
    fr: "Les J",
    ar: "J",
    es: "J",
  },
  "account.points.term3Strong": {
    tr: "üyeler arasında devredilemez",
    en: "cannot be transferred between members",
    de: "kann nicht zwischen Mitgliedern übertragen werden",
    fr: "ne sont pas transférables entre membres",
    ar: "غير قابل للتحويل بين الأعضاء.",
    es: "no puede transferirse entre miembros",
  },
  "account.points.term4Pre": {
    tr: "J yalnızca",
    en: "J can only be spent at the venue on",
    de: "J kann im Club nur",
    fr: "J peut être utilisé uniquement",
    ar: "J فقط",
    es: "J solo se puede gastar en el local los",
  },
  "account.points.term4Strong": {
    tr: "Cuma ve Cumartesi günleri",
    en: "Fridays and Saturdays",
    de: "freitags und samstags",
    fr: "les vendredis et samedis",
    ar: "أيام الجمعة والسبت",
    es: "viernes y sábados",
  },
  "account.points.term4Post": {
    tr: "mekanda harcanabilir.",
    en: ".",
    de: "ausgegeben werden.",
    fr: "sur place.",
    ar: "يمكن إنفاقه في المكان.",
    es: ".",
  },
  "account.points.term5Pre": {
    tr: "Sezon sonunda kullanılmayan J",
    en: "Unused J",
    de: "Nicht genutztes J",
    fr: "Les J non utilisés à la fin de la saison",
    ar: "رصيد J غير المستخدم في نهاية الموسم",
    es: "J no utilizado",
  },
  "account.points.term5Strong": {
    tr: "geçersiz hale gelir",
    en: "expires at the end of the season",
    de: "verfällt am Ende der Saison",
    fr: "deviennent invalides",
    ar: "يصبح غير صالح.",
    es: "expira al final de la temporada",
  },
  "account.points.history": {
    tr: "Hareketler",
    en: "History",
    de: "Verlauf",
    fr: "Activités",
    ar: "التحركات",
    es: "Historial",
  },
  "account.points.noHistory": {
    tr: "Henüz J hareketi yok.",
    en: "No J activity yet.",
    de: "Noch keine J-Aktivität.",
    fr: "Aucune activité J pour le moment.",
    ar: "لا توجد تحركات J بعد.",
    es: "Aún no hay actividad de J.",
  },
  "account.points.type.earn": {
    tr: "Kazanım",
    en: "Earned",
    de: "Erhalten",
    fr: "Gain",
    ar: "مكتسب",
    es: "Ganado",
  },
  "account.points.type.spend": {
    tr: "Harcama",
    en: "Spent",
    de: "Ausgegeben",
    fr: "Dépense",
    ar: "إنفاق",
    es: "Gastado",
  },
  "account.points.type.purchase": {
    tr: "Satın alma",
    en: "Purchase",
    de: "Kauf",
    fr: "Achat",
    ar: "شراء",
    es: "Compra",
  },
  "account.points.type.adminAdjust": {
    tr: "Admin düzenleme",
    en: "Admin adjustment",
    de: "Admin-Anpassung",
    fr: "Modification admin",
    ar: "تعديل المسؤول",
    es: "Ajuste administrativo",
  },
  "account.reservations.status.pending": {
    tr: "Beklemede",
    en: "Pending",
    de: "Ausstehend",
    fr: "En attente",
    ar: "قيد الانتظار",
    es: "Pendiente",
  },
  "account.reservations.status.confirmed": {
    tr: "Onaylandı",
    en: "Confirmed",
    de: "Bestätigt",
    fr: "Approuvé",
    ar: "تمت الموافقة",
    es: "Confirmado",
  },
  "account.reservations.status.rejected": {
    tr: "Reddedildi",
    en: "Rejected",
    de: "Abgelehnt",
    fr: "Refusé",
    ar: "مرفوض",
    es: "Rechazado",
  },
  "account.reservations.status.cancelled": {
    tr: "İptal",
    en: "Cancelled",
    de: "Storniert",
    fr: "Annuler",
    ar: "إلغاء",
    es: "Cancelado",
  },
  "account.reservations.title": {
    tr: "Rezervasyonlarım",
    en: "My Reservations",
    de: "Meine Reservierungen",
    fr: "Mes réservations",
    ar: "حجوزاتي",
    es: "Mis reservas",
  },
  "account.reservations.subtitle": {
    tr: "Onaylanan rezervasyonlar için WhatsApp üzerinden size ulaşacağız.",
    en: "We'll reach out to you via WhatsApp for confirmed reservations.",
    de: "Bei bestätigten Reservierungen melden wir uns per WhatsApp bei dir.",
    fr: "Nous vous contacterons via WhatsApp pour les réservations confirmées.",
    ar: "سنتواصل معك عبر واتساب للحجوزات المؤكدة.",
    es: "Nos pondremos en contacto contigo vía WhatsApp para las reservas confirmadas.",
  },
  "account.reservations.empty": {
    tr: "Henüz rezervasyon talebiniz yok.",
    en: "You don't have any reservation requests yet.",
    de: "Du hast noch keine Reservierungsanfragen.",
    fr: "Vous n'avez aucune demande de réservation pour le moment.",
    ar: "ليس لديك طلبات حجز بعد.",
    es: "Aún no tienes ninguna solicitud de reserva.",
  },
  "account.reservations.viewEvents": {
    tr: "Etkinlikleri görün",
    en: "View events",
    de: "Events ansehen",
    fr: "Voir les événements",
    ar: "عرض الفعاليات",
    es: "Ver eventos",
  },
  "account.reservations.partySizeError": {
    tr: "Kişi sayısı en az 3 olmalı (maks 50)",
    en: "Party size must be at least 3 (max 50)",
    de: "Die Personenzahl muss mindestens 3 sein (max. 50)",
    fr: "Le nombre de personnes doit être d'au moins 3 (max 50)",
    ar: "يجب أن يكون عدد الأشخاص 3 على الأقل (بحد أقصى 50)",
    es: "El tamaño del grupo debe ser de al menos 3 (máximo 50)",
  },
  "account.reservations.partySizeUpdated": {
    tr: "Kişi sayısı güncellendi",
    en: "Party size updated",
    de: "Personenzahl aktualisiert",
    fr: "Nombre de personnes mis à jour",
    ar: "تم تحديث عدد الأشخاص",
    es: "Tamaño del grupo actualizado",
  },
  "account.reservations.requestedAt": {
    tr: "Talep:",
    en: "Requested:",
    de: "Angefragt:",
    fr: "Demande :",
    ar: "الطلب:",
    es: "Solicitado:",
  },
  "account.reservations.personMin": {
    tr: "{size} kişi · min. {amount} ₺",
    en: "{size} people · min. {amount} ₺",
    de: "{size} Personen · mind. {amount} ₺",
    fr: "{size} personnes · min. {amount} ₺",
    ar: "{size} أشخاص · حد أدنى {amount} ₺",
    es: "{size} personas · mín. {amount} ₺",
  },
  "account.reservations.editPartySize": {
    tr: "Kişi sayısını düzenle",
    en: "Edit party size",
    de: "Personenzahl bearbeiten",
    fr: "Modifier le nombre de personnes",
    ar: "تعديل عدد الأشخاص",
    es: "Editar tamaño del grupo",
  },
  "account.reservations.yourNote": {
    tr: "Notunuz:",
    en: "Your note:",
    de: "Deine Notiz:",
    fr: "Votre note :",
    ar: "ملاحظاتك:",
    es: "Tu nota:",
  },
  "account.reservations.rejectedTitle": {
    tr: "Talep onaylanmadı",
    en: "Request was not approved",
    de: "Anfrage wurde nicht angenommen",
    fr: "Demande non approuvée",
    ar: "لم يتم تأكيد الطلب",
    es: "Solicitud no aprobada",
  },
  "account.reservations.confirmedTitle": {
    tr: "Rezervasyonunuz onaylandı 🎉",
    en: "Your reservation is confirmed 🎉",
    de: "Deine Reservierung wurde bestätigt 🎉",
    fr: "Votre réservation est confirmée 🎉",
    ar: "تم تأكيد حجزك 🎉",
    es: "Tu reserva está confirmada 🎉",
  },
  "account.reservations.confirmedDesc": {
    tr: "Detaylar için WhatsApp üzerinden size ulaşacağız.",
    en: "We'll contact you via WhatsApp with the details.",
    de: "Wir melden uns mit den Details per WhatsApp bei dir.",
    fr: "Nous vous contacterons via WhatsApp pour les détails.",
    ar: "سنتواصل معك عبر واتساب للحصول على التفاصيل.",
    es: "Te contactaremos vía WhatsApp con los detalles.",
  },
  "account.reservationDialog.trigger": {
    tr: "Masa rezervasyonu",
    en: "Table reservation",
    de: "Tischreservierung",
    fr: "Réservation de table",
    ar: "حجز طاولة",
    es: "Reserva de mesa",
  },
  "account.reservationDialog.selectDate": {
    tr: "Tarih seçin",
    en: "Select a date",
    de: "Wähle ein Datum",
    fr: "Sélectionnez une date",
    ar: "اختر التاريخ",
    es: "Seleccionar una fecha",
  },
  "account.reservationDialog.submitted": {
    tr: "Talebiniz alındı, en kısa sürede dönüş yapacağız.",
    en: "Your request has been received, we'll get back to you shortly.",
    de: "Deine Anfrage ist eingegangen, wir melden uns bald bei dir.",
    fr: "Votre demande a été reçue, nous vous répondrons dès que possible.",
    ar: "تم استلام طلبك، وسنرد عليك في أقرب وقت ممكن.",
    es: "Tu solicitud ha sido recibida, nos pondremos en contacto contigo en breve.",
  },
  "account.reservationDialog.existingPre": {
    tr: "Bu etkinlik için zaten bir rezervasyon talebiniz var",
    en: "You already have a reservation request for this event",
    de: "Du hast bereits eine Reservierungsanfrage für dieses Event",
    fr: "Vous avez déjà une demande de réservation pour cet événement",
    ar: "لديك بالفعل طلب حجز لهذا الحدث",
    es: "Ya tienes una solicitud de reserva para este evento",
  },
  "account.reservationDialog.existingConfirmedSuffix": {
    tr: " ve onaylandı",
    en: " and it's confirmed",
    de: " und sie wurde bestätigt",
    fr: " et elle a été approuvée",
    ar: " وتمت الموافقة عليه",
    es: " y está confirmada",
  },
  "account.reservationDialog.existingPost": {
    tr: "Kişi sayısını değiştirmek için",
    en: "To change the party size, use the",
    de: "Um die Personenzahl zu ändern, nutze die",
    fr: "Pour changer le nombre de personnes",
    ar: "لتغيير عدد الأشخاص، يرجى استخدام",
    es: "Para cambiar el tamaño del grupo, usa la",
  },
  "account.reservationDialog.existingPostEnd": {
    tr: "sayfasını kullanın.",
    en: "page.",
    de: "Seite.",
    fr: "utilisez la page.",
    ar: "الصفحة.",
    es: "página.",
  },
  "account.reservationDialog.partySizeLabel": {
    tr: "Kişi sayısı",
    en: "Party size",
    de: "Personenzahl",
    fr: "Nombre de personnes",
    ar: "عدد الأشخاص",
    es: "Tamaño del grupo",
  },
  "account.reservationDialog.minSpendHint": {
    tr: "Masa rezervasyonu minimum 3 kişiliktir. Minimum harcama: {amount} ({size} kişi × 3.000 ₺). Etkinlik bileti dahildir.",
    en: "Table reservations require a minimum of 3 people. Minimum spend: {amount} ({size} people × 3,000 ₺). Event ticket included.",
    de: "Tischreservierungen erfordern mindestens 3 Personen. Mindestumsatz: {amount} ({size} Personen × 3.000 ₺). Eventticket inklusive.",
    fr: "La réservation de table est pour un minimum de 3 personnes. Dépense minimale : {amount} ({size} personnes × 3 000 ₺). Billet d'événement inclus.",
    ar: "حجز الطاولة لـ 3 أشخاص على الأقل. الحد الأدنى للإنفاق: {amount} ({size} أشخاص × 3,000 ₺). تذاكر الحدث متضمنة.",
    es: "Las reservas de mesa requieren un mínimo de 3 personas. Consumo mínimo: {amount} ({size} personas × 3.000 ₺). Entrada del evento incluida.",
  },
  "account.reservationDialog.dateLabel": {
    tr: "Tarih ve saat",
    en: "Date and time",
    de: "Datum und Uhrzeit",
    fr: "Date et heure",
    ar: "التاريخ والوقت",
    es: "Fecha y hora",
  },
  "account.reservationDialog.notesLabel": {
    tr: "Not (opsiyonel)",
    en: "Note (optional)",
    de: "Notiz (optional)",
    fr: "Note (facultatif)",
    ar: "ملاحظة (اختياري)",
    es: "Nota (opcional)",
  },
  "account.reservationDialog.notesPlaceholder": {
    tr: "Özel istek, doğum günü, vb.",
    en: "Special requests, birthday, etc.",
    de: "Sonderwünsche, Geburtstag, usw.",
    fr: "Demande spéciale, anniversaire, etc.",
    ar: "طلب خاص، عيد ميلاد، إلخ.",
    es: "Peticiones especiales, cumpleaños, etc.",
  },
  "account.reservationDialog.submit": {
    tr: "Talep gönder",
    en: "Send request",
    de: "Anfrage senden",
    fr: "Envoyer la demande",
    ar: "إرسال الطلب",
    es: "Enviar solicitud",
  },
  "account.reservationDialog.submittedDesc": {
    tr: "Talebiniz alındı. Onaylandığı takdirde WhatsApp üzerinden size ulaşacağız. Onaylanmazsa rezervasyonlarım sayfasından durumu görebilirsiniz.",
    en: "Your request has been received. If approved, we'll reach out to you via WhatsApp. If not, you can check the status on the My Reservations page.",
    de: "Deine Anfrage ist eingegangen. Bei Bestätigung melden wir uns per WhatsApp bei dir. Andernfalls kannst du den Status auf der Seite „Meine Reservierungen“ einsehen.",
    fr: "Votre demande a été reçue. Nous vous contacterons via WhatsApp si elle est approuvée. Si elle n'est pas approuvée, vous pouvez consulter le statut sur la page de mes réservations.",
    ar: "تم استلام طلبك. في حال الموافقة، سنتواصل معك عبر واتساب. إذا لم يتم تأكيده، يمكنك رؤية الحالة في صفحة حجوزاتي.",
    es: "Tu solicitud ha sido recibida. Si es aprobada, te contactaremos vía WhatsApp. Si no, puedes comprobar el estado en la página Mis Reservas.",
  },
};
